import SubmissionListSection from "./components/submission-list-section";

const Submissions = () => {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Schools List - Takes remaining height */}
      <div className="h-full">
        <SubmissionListSection />
      </div>
    </div>
  );
};

export default Submissions;
